<template>
  <section class="invoice-preview-wrapper">
    <!-- Alert: No item found -->
    <b-alert variant="danger" :show="quoteData === undefined">
      <h4 class="alert-heading">Error fetching quote data</h4>
      <div class="alert-body">
        No quote found with this quote id. Check
        <b-link class="alert-link" :to="{ name: 'apps-quote-list' }">
          quote List
        </b-link>
        for other quotes.
      </div>
    </b-alert>

    <b-row v-if="quoteData" class="invoice-preview">
      <!-- Col: Left (Invoice Container) -->
      <b-col cols="12" xl="9" md="8">
        <b-card no-body class="invoice-preview-card size-print-page">
          <!-- Header -->
          <b-card-body class="invoice-padding pb-0">
            <div
              class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0"
            >
              <!-- Header: Left Content -->
              <div>
                <div class="logo-wrapper">
                  <logo />
                  <h3 class="text-primary invoice-logo">ERP NewTech</h3>
                </div>
                <b-card-text class="mb-25">
                  {{ user.adress }}
                </b-card-text>
                <b-card-text class="mb-25">
                  {{ user.ville }}, {{ user.city }}, {{ user.postalCode }}
                </b-card-text>
                <b-card-text class="mb-0">
                  {{ user.PhoneNumber }}
                </b-card-text>
              </div>

              <!-- Header: Right Content -->
              <div class="mt-md-0 mt-2">
                <h4 class="invoice-title">
                  Devis
                  <span class="invoice-number">#{{ quoteData.code }}</span>
                </h4>
                <div class="invoice-date-wrapper">
                  <p class="invoice-date-title">Date de cré:</p>
                  <p class="invoice-date">
                    {{ externalDateFormat(quoteData.createdAt) }}
                  </p>
                </div>
                <div class="invoice-date-wrapper">
                  <p class="invoice-date-title">Date limite:</p>
                  <p class="invoice-date">
                    {{ externalDateFormat(quoteData.deliveryDate) }}
                  </p>
                </div>
              </div>
            </div>
          </b-card-body>

          <!-- Spacer -->
          <hr class="invoice-spacing" />

          <!-- Invoice supplier & Payment Details -->
          <b-card-body v-if="quoteData.supplier" class="invoice-padding pt-0">
            <b-row class="invoice-spacing">
              <!-- Col: Invoice To -->
              <b-col cols="12" xl="6" class="p-0">
                <h6 class="mb-2">Devis à:</h6>
                <h6 class="mb-25">
                  {{ quoteData.supplier.firstName }}
                  {{ quoteData.supplier.lastName }}
                </h6>
                <!-- <b-card-text class="mb-25">
                      {{ supplier.company }}
                    </b-card-text> -->
                <b-card-text class="mb-25">
                  {{ quoteData.supplier.address }},
                  {{ quoteData.supplier.city }}
                </b-card-text>
                <b-card-text class="mb-25">
                  {{ quoteData.supplier.email }}
                </b-card-text>
                <b-card-text class="mb-0">
                  {{ quoteData.supplier.telNumbers.toString() }}
                </b-card-text>
              </b-col>

              <!-- Col: Payment Details -->
              <b-col
                xl="6"
                cols="12"
                class="p-0 mt-xl-0 mt-2 d-flex justify-content-xl-end"
              >
                <div>
                  <h6 class="mb-2">Détails paiement:</h6>
                  <table>
                    <tbody>
                      <tr>
                        <td class="pr-1">Nom du bank :</td>
                        <td>Biat</td>
                      </tr>
                      <tr>
                        <td class="pr-1">Pays:</td>
                        <td>Tunisie</td>
                      </tr>
                      <tr>
                        <td class="pr-1">IBAN:</td>
                        <td>ETD95476213874685</td>
                      </tr>
                      <tr>
                        <td class="pr-1">code SWIFT:</td>
                        <td>BR91905</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-col>
            </b-row>
          </b-card-body>

          <!-- Invoice Description: Table -->
          <b-table-lite
            responsive
            :items="quoteData.products"
            :fields="[
              { key: 'index', label: '#' },
              { key: 'product', label: 'Désignation' },
              { key: 'productPrice', label: 'Prix' },
              { key: 'quantity', label: 'Qté/Heu' },
              { key: 'valueAddedTax', label: 'Taxe' },
              { key: 'TotalePriceDutyFree', label: 'Totale HT' },
            ]"
          >
            <template #cell(index)="dataIndex">
              {{ dataIndex.index + 1 }}
            </template>
            <template #cell(product)="dataProduct">
              <b-card-text class="font-weight-bold mb-25">
                {{ dataProduct.item.product.label }}
              </b-card-text>
              <b-card-text class="text-nowrap product-description">
                {{ dataProduct.item.description }}
              </b-card-text>
            </template>
            <template #cell(productPrice)="dataPrice">
              {{ dataPrice.item.product.priceWithoutTaxes }}
            </template>
            <template #cell(quantity)="dataQuantity">
              {{ dataQuantity.item.quantity }}
              {{ dataQuantity.item.quantityType }}
            </template>
            <template #cell(TotalePriceDutyFree)="dataPrice">
              {{
                dataPrice.item.product.priceWithoutTaxes *
                dataPrice.item.quantity
              }}
            </template>
          </b-table-lite>

          <!-- Invoice Description: Total -->
          <b-card-body class="invoice-padding pb-0 price-footer-print">
                                       <hr class="invoice-spacing" />

            <b-row>
              <!-- Col: Sales Persion -->
              <b-col
                cols="12"
                md="6"
                class="mt-md-0 mt-3 remove-element-print"
                order="2"
                order-md="1"
              >
                <b-card-text class="mb-0">
                  <span class="font-weight-bold">Vendeur:</span>
                  <span class="ml-75">{{ quoteData.salesperson }}</span>
                </b-card-text>
              </b-col>
  <b-col
                  cols="12"
                  md="6"
                  class="mt-md-0 mt-3 add-element-print"
                  order="2"
                  order-md="1"
                >
                  <b-card-text class="mb-0" v-if="printWithSignature">
                    <span class="font-weight-bold">Signature:</span>
                 <span class="mlt-50">   <img :src="user.signature" alt="signature" class="print-signature"></span>
                  </b-card-text>
              </b-col>
              <!-- Col: Total -->
              <b-col
                cols="12"
                md="6"
                class="mt-md-6 d-flex justify-content-end"
                order="1"
                order-md="2"
              >
                <div class="invoice-total-wrapper">
                  <div class="invoice-total-item">
                    <p class="invoice-total-title">Timbre:</p>
                    <p class="invoice-total-amount">
                      {{ quoteData.stampPrice }} {{ externalUserCurrency() }}
                    </p>
                  </div>
                  <div class="invoice-total-item">
                    <p class="invoice-total-title">Totale HT:</p>
                    <p class="invoice-total-amount">
                      {{ quoteData.priceWithoutTaxes }}
                      {{ externalUserCurrency() }}
                    </p>
                  </div>
                  <div class="invoice-total-item">
                    <p class="invoice-total-title">Tax:</p>
                    <p class="invoice-total-amount">
                      {{ quoteData.valueAddedTax }} {{ externalUserCurrency() }}
                    </p>
                  </div>
                  <div class="invoice-total-item">
                    <p class="invoice-total-title">Totale av tax:</p>
                    <p class="invoice-total-amount">
                      {{
                        quoteData.valueAddedTax + quoteData.priceWithoutTaxes
                      }}
                      {{ externalUserCurrency() }}
                    </p>
                  </div>
                  <div class="invoice-total-item">
                    <p class="invoice-total-title">Remise:</p>
                    <p class="invoice-total-amount">
                      {{ quoteData.totalDiscount }} {{ externalUserCurrency() }}
                    </p>
                  </div>
                  <hr class="my-50" />
                  <div class="invoice-total-item">
                    <p class="invoice-total-title">Totale TTC:</p>
                    <p class="invoice-total-amount">
                      {{ quoteData.allTaxesIncluded }}
                      {{ externalUserCurrency() }}
                    </p>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-card-body>

          <!-- Spacer -->
          <hr class="invoice-spacing" />

          <!-- Note -->
          <b-card-body class="invoice-padding pt-0 remove-element-print" v-if="quoteData.note">
            <span class="font-weight-bold">Note: </span>
            <span>{{ quoteData.note }}</span>
          </b-card-body>
          <b-card-body class="invoice-padding pt-0 remove-element-print" v-if="quoteData.paymentTerms">
            <span class="font-weight-bold">Terme : </span>
            <span>{{ quoteData.paymentTerms }}</span>
          </b-card-body>
        </b-card>
      </b-col>

      <!-- Right Col: Card -->
      <b-col cols="12" md="4" xl="3" class="invoice-actions">
        <b-card>
          <!-- Button: Send Invoice -->
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            v-b-toggle.sidebar-send-email
            variant="primary"
            class="mb-75"
            block
          >
            Envoyé devis
          </b-button>

          <!-- Button: DOwnload -->
          <!-- <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            class="mb-75"
            block
          >
            Télécharger
          </b-button> -->

          <!-- Button: Print -->
          <b-button v-if="user.signature"
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            class="mb-75"
            block
            @click="printInvoice(false)"
          >
            Imprimer avec signature
          </b-button>
   <b-button v-if="user.signature"
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            class="mb-75"
            block
            @click="printInvoice(true)"
          >
            Imprimer sans signature
          </b-button>
          <b-button v-if="!user.signature"
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            class="mb-75"
            block
            @click="printInvoice(true)"
          >
            Imprimer signature
          </b-button>

          <!-- Button: Edit -->
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            class="mb-75"
            block
            @click="UpdateQuote()"
          >
            Modifier
          </b-button>

          <!-- Button: Add Payment -->
          <!-- <b-button
            v-b-toggle.sidebar-invoice-add-payment
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="success"
            class="mb-75"
            block
          >
            Add Payment
          </b-button> -->
        </b-card>
      </b-col>
    </b-row>

    <sidebar-send-email
      :data="{
        name: 'Devis',
        email:quoteData.supplier.email,
        code: quoteData.code,
      }"
    />
  </section>
</template>

<script>
// utils
import { DateFormat } from "@/utils/filter.js";
import { GetLinkCurrency } from "@/utils/utils.js";
import store from "@/store";
import router from "@/router";
import axios from "axios";
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BTableLite,
  BCardText,
  BButton,
  BAlert,
  BLink,
  VBToggle,
} from "bootstrap-vue";
import Logo from "@core/layouts/components/Logo.vue";
import Ripple from "vue-ripple-directive";
import SidebarSendEmail from "./../../composants/sidebar/SidebarSendEmail.vue";

export default {
  directives: {
    Ripple,
    "b-toggle": VBToggle,
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BTableLite,
    BCardText,
    BButton,
    BAlert,
    BLink,
    Logo,
    SidebarSendEmail,
  },
  data() {
    return {
      printWithSignature:false,
      quoteData: {},
      user: {
        adress: "lorem ipsum is my location",
        ville: "tunis",
        city: "Tunisia",
        postalCode: "1000",
        PhoneNumber: "99777555",
        signature:"https://upload.wikimedia.org/wikipedia/commons/thumb/5/56/Autograph_of_Benjamin_Franklin.svg/1200px-Autograph_of_Benjamin_Franklin.svg.png"
      },
    };
  },
  async created() {
    await this.getQuoteDetails();
  },
  methods: {
    // external Filter
    externalDateFormat(date) {
      return DateFormat(date);
    },
    // external utils
    externalUserCurrency() {
      return GetLinkCurrency();
    },
    // Other function
    // print
     printInvoice(arg) {
      this.printWithSignature=arg
      window.print();
    },
    UpdateQuote() {
      var routerLink =
        "/shop/quote/edit-quote?id=" + this.$router.history.current.query.id;
      this.$router.replace(routerLink);
    },
    getQuoteDetails() {
      axios
        .get(
          "https://management-projects.herokuapp.com/api/purchase-quotations/" +
            this.$router.history.current.query.id
        )
        .then((response) => {
          this.quoteData = response.data;
        })
        .catch((error) => {
          this.errorMessage = error.message;
        });
      this.quoteData = {
        paymentMethod: "",
        salesperson: "user test",
        note:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio pariatur modi iusto officia sint, quis hic autem. Nihil officiis placeat sint est optio? Accusantium suscipit enim neque laudantium in et.",
        paymentTerms:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio pariatur modi iusto officia sint, quis hic autem. Nihil officiis placeat sint est optio? Accusantium suscipit enim neque laudantium in et.",
        code: null,
        createdAt: new Date(),
        code: null,
        supplier: {
          name: "test",
          lastName: "supplier",
          email: "clien.test@gmail.com",
          telNumbers: ["99888777"],
          address: "adresse supplier",
          city: "tunisie",
        },
        deliveryDate: null,
        status: "",
        description: "",
        products: [
          {
            product: {
              label: "produit test",
              priceWithoutTaxes: 1000,
            },
            quantity: 2,
            valueAddedTax: 5,
            discount: 10,
            description: "lorem ipsum is the best article",
            quantityType: "Quantité(s)",
          },
          {
            product: {
              label: "produit test",
              priceWithoutTaxes: 3000,
            },
            quantity: 1,
            valueAddedTax: 0,
            discount: 0,
            description: "",
            quantityType: "Heure(s) ",
          },
        ],
        priceWithoutTaxes: 1000,
        valueAddedTax: 100,
        allTaxesIncluded: 1000,
        totalDiscount: 110,
        stampPrice: 10, //timbre
        warehouse: "",
        images: [],
        createdBy: JSON.parse(localStorage.getItem("userData"))._id,
      };
    },
    // filters
  },
  // setup() {
  //   const quoteData = ref(null);
  //   const paymentDetails = ref({});

  //   // Invoice Description
  //   // ? Your real data will contain this information
  //   const invoiceDescription = [
  //     {
  //       taskTitle: "Native App Development",
  //       taskDescription:
  //         "Developed a full stack native app using React Native, Bootstrap & Python",
  //       rate: "$60.00",
  //       hours: "30",
  //       total: "$1,800.00",
  //     },
  //     {
  //       taskTitle: "UI Kit Design",
  //       taskDescription:
  //         "Designed a UI kit for native app using Sketch, Figma & Adobe XD",
  //       rate: "$60.00",
  //       hours: "20",
  //       total: "$1200.00",
  //     },
  //   ];

  //   const INVOICE_APP_STORE_MODULE_NAME = "app-invoice";

  //   // Register module
  //   if (!store.hasModule(INVOICE_APP_STORE_MODULE_NAME))
  //     store.registerModule(INVOICE_APP_STORE_MODULE_NAME, invoiceStoreModule);

  //   // UnRegister on leave
  //   onUnmounted(() => {
  //     if (store.hasModule(INVOICE_APP_STORE_MODULE_NAME))
  //       store.unregisterModule(INVOICE_APP_STORE_MODULE_NAME);
  //   });

  //   store
  //     .dispatch("app-invoice/fetchInvoice", {
  //       id: router.currentRoute.params.id,
  //     })
  //     .then((response) => {
  //       quoteData.value = response.data.invoice;
  //       paymentDetails.value = response.data.paymentDetails;
  //     })
  //     .catch((error) => {
  //       if (error.response.status === 404) {
  //         quoteData.value = undefined;
  //       }
  //     });

  //   const printInvoice = () => {
  //     window.print();
  //   };

  //   return {
  //     quoteData,
  //     paymentDetails,
  //     invoiceDescription,
  //     printInvoice,
  //   };
  // },
};
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
</style>

<style lang="scss">
@media print {
  // Global Styles
  body {
    background-color: transparent !important;
  }
  nav.header-navbar {
    display: none;
  }
  .main-menu {
    display: none;
  }
  .header-navbar-shadow {
    display: none !important;
  }
  .content.app-content {
    margin-left: 0;
    padding-top: 2rem !important;
  }
  footer.footer {
    display: none;
  }
  .card {
    background-color: transparent;
    box-shadow: none;
  }
  .customizer-toggle {
    display: none !important;
  }

  // Invoice Specific Styles
  .invoice-preview-wrapper {
    .row.invoice-preview {
      .col-md-8 {
        max-width: 100%;
        flex-grow: 1;
      }

      .invoice-preview-card {
        .card-body:nth-of-type(2) {
          .row {
            > .col-12 {
              max-width: 50% !important;
            }

            .col-12:nth-child(2) {
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              margin-top: 0 !important;
            }
          }
        }
      }
    }

    // Action Right Col
    .invoice-actions {
      display: none;
    }
  }
}
.product-description {
  font-size: 12px !important;
}
</style>
